import type { IconProps } from '@launchpad-ui/icons';
import { Icon } from '@launchpad-ui/icons';

export function DatabricksIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <use href="#app-icon-databricks" />
    </Icon>
  );
}
